<template>
  <div class="grid-container">
    <template v-for="(item, index) in layout" :key="index">
      <div v-if="components?.[item?.widget?.component] && item?.show" :class="`grid-item grid-item-${$_.kebabCase(item.widget.component)}`" :style="`grid-area:${item.y + 1}/${item.x + 1}/span ${item.h || 1}/span ${item.w || 1}`">
        <component :is="components[item.widget.component]" :config="{ config: item.widget.data || {}, data: item.data || {}, query: config.query }" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    layout() {
      return this.config?.layout || []
    },
    components() {
      return this.config?.components || {}
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0 24px;
  .grid-item {
    margin-bottom: 24px;
    border-radius: var(--border-radius, 0.25rem);
    overflow: hidden;
  }
}
</style>
